export const getStyles = () => ({
  addTextStep: {
    '& .ad-type-selector': {
      marginBottom: '16px',

      '& .ad-type-label': {
        display: 'flex',
        alignItems: 'center',
      },

      '& .ad-type-dropdown': {
        width: '600px',
      },
    },
    '& .ad-footer': {
      display: 'flex',
      flexDirection: 'row',
      gap: '16px',
      marginTop: '32px',
    },
  },
});
